const styles = {
  pageWrapperSx: {
    px: { xs: 2, sm: 3, md: 5 },
    mt: { xs: 4, md: 10 },
    maxWidth: "1200px",
    mx: "auto",
  },

  imageSx: {
    display: "block",
    objectFit: "cover",
    backgroundColor: "#1a1a1a",
    maxHeight: "620px",
    float: { xs: "none", md: "left" },
    width: { xs: "100%", md: "45%" },
    maxWidth: "480px",
    marginLeft: { xs: "auto", md: 0 },
    marginRight: { xs: "auto", md: 4 },
    mb: 3,
  },

  titleSx: {
    textAlign: { xs: "center", md: "left" },
    mb: 1,
    color: "white",
  },

  nameSx: { color: "white", mb: 2, textAlign: { xs: "center", md: "left" } },

  genresRowSx: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "flex-start" },
    gap: 1,
    mb: 2,
  },

  socialRowSx: {
    display: "flex",
    gap: "40px",
    paddingRight: { xs: 0, md: "18px" },
    justifyContent: { xs: "center", md: "flex-start" },
  },

  socialIconSx: { width: "48px", height: "48px" },

  descriptionSx: {
    textAlign: { xs: "center", md: "left" },
    color: "white",
    mt: 5,
    fontSize: 15,
    lineHeight: 1.7,
    "& p": { marginBottom: "1em", textAlign: "inherit" },
    "& ul, & ol": {
      paddingLeft: "1.5em",
      paddingRight: { xs: "1.5em", md: 0 },
      marginBottom: "1em",
    },
    "& strong": { fontWeight: 600 },
    "& em": { fontStyle: "italic" },
    "& *": { color: "inherit" },
  },

  clearSx: { clear: "both" },
};

export default styles;
